var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "27px",
    viewBox: "0 0 33 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "users") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "community",
    transform: "translate(-36, -283)",
    fill: "#262262",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(36, 283.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2449216,16.25 C19.1602733,16.25 21.4804688,13.8856251 21.4804688,10.96875 C21.4804688,8.05187488 19.1171089,5.6875 16.2449216,5.6875 C13.3295698,5.6875 11.0093744,8.05187488 11.0093744,10.96875 C10.9636716,13.8835934 13.3300781,16.25 16.2449216,16.25 Z M18.7839841,17.875 L13.7160159,17.875 C9.72968781,17.875 6.5,20.9066412 6.5,24.64414 C6.5,25.3957034 7.14492172,26 7.94218719,26 L24.5578128,26 C25.3550775,26 26,25.3957034 26,24.64414 C26,20.9066412 22.7703122,17.875 18.7839841,17.875 Z M26,8.125 C28.2435153,8.125 30.0625,6.30601525 30.0625,4.0625 C30.0625,1.81898475 28.2445319,0 26,0 C23.7564847,0 21.9375,1.81898475 21.9375,4.0625 C21.9375,6.30601525 23.7554681,8.125 26,8.125 Z M9.33867157,10.96875 C9.33867157,10.6920427 9.3885594,10.4289451 9.42037827,10.1608201 C8.86640656,9.85664093 8.25703156,9.75 7.61210907,9.75 L4.47281259,9.75 C2.00281262,9.75 0,11.8726564 0,14.48789 C0,15.0109378 0.400511384,15.4375 0.894765377,15.4375 L11.0256248,15.4375 C9.98867172,14.2289069 9.33867157,12.680078 9.33867157,10.96875 Z M6.5,8.125 C8.74351525,8.125 10.5625,6.30601525 10.5625,4.0625 C10.5625,1.81898475 8.7445311,0 6.5,0 C4.25648397,0 2.43749923,1.81898475 2.43749923,4.0625 C2.43749923,6.30601525 4.25648397,8.125 6.5,8.125 Z M28.0261731,9.75 L24.8858608,9.75 C24.2358614,9.75 23.6224231,9.90422279 23.0648444,10.1684378 C23.0953119,10.4355469 23.1460931,10.6945316 23.1460931,10.96875 C23.1460931,12.6805855 22.4971088,14.2294136 21.4621867,15.4375 L31.6032014,15.4375 C32.0988269,15.4375 32.5,15.0109378 32.5,14.48789 C32.5,11.8726564 30.4992175,9.75 28.0261731,9.75 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.3b5f7840e89a3fd1bbf08ee5632be79d.svg";
export { ForwardRef as ReactComponent };